__turbopack_context__.v({
  "featured_news_row": "UMHI2a_featured_news_row",
  "featured_news_row_splide_arrow": "UMHI2a_featured_news_row_splide_arrow",
  "featured_news_row_title": "UMHI2a_featured_news_row_title",
});
